module.exports = __webpack_public_path__ + "static/media/banner-image3cap.9441bc70.png";